const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const ORD = { 1: "1st", 2: "2nd", 3: "3rd", 4: "4th", 5: "5th" };

// Returns a label like "Weekly Off (2nd Saturday)" when dateStr matches a rule, else null.
export function weeklyOffLabel(dateStr, rules) {
  if (!dateStr || !rules || !rules.length) return null;
  const d = new Date(dateStr + "T00:00:00");
  const day = d.getDay(); // 0=Sun..6=Sat
  const occ = Math.floor((d.getDate() - 1) / 7) + 1;
  for (const r of rules) {
    if (Number(r.day) !== day) continue;
    if (!r.occurrences || r.occurrences.length === 0) return `Weekly Off (${DAYS[day]})`;
    if (r.occurrences.includes(occ)) return `Weekly Off (${ORD[occ]} ${DAYS[day]})`;
  }
  return null;
}

export const WEEKDAYS = DAYS;
export const OCCURRENCES = [1, 2, 3, 4, 5];
